module.exports = __webpack_public_path__ + "img/menu-down.84f813d7.svg";